import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { Spin, Form, Button } from 'antd';

import { Config } from '../../public/js/config';
import $ from 'jquery';
import './login.css';
import Message from '../../component/message/message';
import trans from './translation';
import StatementModal from './statementModal';
import { Base } from '../../public/js/base';

import userLogin from '../../public/img/UserLogin.png';
import loginLogoImg from '../../public/img/loginLogo.png';
import logoImg from '../../public/img/logo.jpg';
import zfzzjhImg from '../../public/img/zfzzjhImg.png';

export let searchCohortYear;

const Login = (props) => {

    const history = useHistory();
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [isStatementModal, setIsStatementModal] = useState(false);
    const [isLoad, setIsLoad] = useState(false);
    const [code, setCode] = useState("");
    const [userModel, setUserModel] = useState({});
    const [shutdownFlag, setShutdownFlag] = useState(false);
    const [shutdownMessage, setShutdownMessage] = useState(false);

    useEffect(() => {
        checkLogin();
        checkShutdownTime();
    }, []);

    const getCode = () => {
        const redirectUri = encodeURIComponent(Config.redirectUri);
        window.location.replace(`${Config.authorizeUri}?client_id=${Config.clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${Config.scope}`);
    }

    const redirectLogin = () => {
        const urlParams = new URL(window.location.href)
        const error = urlParams.searchParams.get("error")
        const code = urlParams.searchParams.get("code")
        if (error) {
            errFrameShow("error", error);
        } else {
            if (!code) {
                getCode()
            } else {
                setCode(code);
            }
        }

    }

    searchCohortYear = () => {
        $.ajax({
            url: Config.apiServer + "student/back/cohort/searchCohortYear",
            type: "POST",
            async: false,
            headers: Config.header,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: (data) => {
                if ("SUCCESS" === data.msg) {
                    Config.cohort = data?.object
                } else {
                    console.log("error", data.msg);
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
            }
        })
    }

    const checkLogin = () => {
        if (Base.isEmpty(Config.header.authorization)) {
            Config.header.authorization = localStorage.getItem(Config.tokenPrefix + 'AccessToken');
        }
        let token = localStorage.getItem(Config.tokenPrefix + 'RefreshToken');
        if (token) {
            $.ajax({
                url: Config.apiServer + "student/login/checkToken",
                type: "POST",
                data: JSON.stringify(token),
                async: false,
                headers: Config.header,
                contentType: "application/json; charset=utf-8",
                dataType: 'json',
                success: (data) => {
                    if ("SUCCESS" === data.msg && data.object.userInfo.userType === 'STUDENT') {
                        Config.userInfo = data.object.userInfo;
                        Config.header.authorization = data.object.accessToken + '';
                        Config.sasToken = data.object.sasToken;
                        localStorage.setItem(Config.tokenPrefix + 'AccessToken', data.object.accessToken);
                        localStorage.setItem(Config.tokenPrefix + 'RefreshToken', data.object.refreshToken);
                        history.push('/student');
                    } else {
                        localStorage.removeItem(Config.tokenPrefix + 'AccessToken');
                        localStorage.removeItem(Config.tokenPrefix + 'RefreshToken');
                        redirectLogin()
                    }
                },
                error: (jqXHR, textStatus, errorThrown) => {
                }
            });
        } else {
            redirectLogin()
        }
    }

    const onFinish = (values) => {
        if(shutdownFlag) {
            errFrameShow('error', shutdownMessage);
            return;
        }
        if (!code) {
            window.location.replace(Config.sysUrl + '#/login');
            return
        }
        values.code = code;
        values.userCode = userModel.userCode
        messageShowHandler();
        setLoading(true);
        fetch(Config.apiServer + "student/login/ajaxLogin", {
            method: 'POST',
            body: JSON.stringify(values),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg && data.object.userInfo.userType === 'STUDENT') {
                let model = data.object.userInfo
                if (model.userType === 'STUDENT' && model.statementInd === 'N') {
                    setUserModel(model)
                    setIsStatementModal(true)
                    return
                }
                Config.userInfo = model;
                Config.header.authorization = data.object.accessToken + '';
                Config.sasToken = data.object.sasToken;
                localStorage.setItem(Config.tokenPrefix + 'AccessToken', data.object.accessToken);
                localStorage.setItem(Config.tokenPrefix + 'RefreshToken', data.object.refreshToken);
                searchCohortYear();
                window.location.replace(Config.sysUrl + '#/student');
            } else {
                errFrameShow("error", data.msg);
                setCode('');
            }
        }).catch(err => { }).finally(() => setLoading(false));
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const closeStatementModal = (flag) => {
        if (flag) {
            confirmStatement()
        } else {
            setIsStatementModal(false)
        }
    }

    const confirmStatement = () => {
        if (isLoad) {
            return
        }
        setIsLoad(true);
        // let model = form.getFieldsValue()
        let model = userModel
        fetch(Config.apiServer + "student/login/confirmStatement", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                setIsStatementModal(false)
                form.submit()
            } else {
                setIsStatementModal(false)
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }
    
    const logout = () => {
        fetch(Config.apiServer + "student/login/lgout", {
            method: 'POST',
            body: JSON.stringify(Config.userInfo),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                Config.userInfo = {};
                Config.studentInfo = {};
                Config.header.authorization = '';
                localStorage.removeItem(Config.tokenPrefix + 'AccessToken');
                localStorage.removeItem(Config.tokenPrefix + 'RefreshToken');
                localStorage.removeItem("wilBackLang");
                window.location.replace(Config.logoutUri);
            } else {
                console.log(data.msg);
            }
        }).catch(err => { }).finally(() => {});
    }

    const checkShutdownTime = () => {
        $.ajax({
            url: Config.apiServer + "student/login/checkShutdownTime",
            type: "POST",
            async: false,
            headers: Config.header,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: (data) => {
                if ("SUCCESS" === data.msg) {
                    setShutdownFlag(false);
                } else {
                    setShutdownFlag(true);
                    setShutdownMessage(data.msg);
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
                setShutdownFlag(true);
                setShutdownMessage('WIL Platform is currently under maintenance.');
            }
        })
    }

    return (
        <div className='login'>
            {isStatementModal && <StatementModal onClose={closeStatementModal} />}
            <div className='logoBox'>
                <img src={loginLogoImg} />
            </div>
            <div className='line'></div>
            <div className='loginBackground'>
                {/* 错误信息弹框 */}
                <div className='loginMessageBox'>
                    <Message ref={messageRef} />
                </div>
                {shutdownFlag && <div className='tipBox tipErrorBox'>
                    {shutdownMessage}
                </div>}
                {/* <div className='tipBox'>
                    <div>This is a User Testing environment using simulated data, which means the information provided is not real.</div>
                    <div>Please refrain from sharing any real personal data during testing.</div>
                </div> */}
                <div className='loginBox'>
                    <div className='loginLogoBox'>
                        <img src={logoImg} />
                    </div>
                    <div className="textBox">
                        <Spin spinning={loading}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='title'>{trans.title[Config.backLang]}</div>
                                <Button icon={<img src={userLogin} />} type="primary" htmlType="submit" className="loginFormButton" disabled={loading}>{trans.login[Config.backLang]}</Button>
                            </Form>
                            <div className="botButtonDiv" style={{ marginTop: '20px' }}>
                                <div className='sysUpdate' onClick={() => history.push("/indexAbout")}>About</div>
                                <div className='sysUpdate' onClick={() => history.push("/help")}>Help</div>
                                <div className='sysUpdate' onClick={() => logout()}>Logout</div>
                            </div>
                        </Spin>
                    </div>
                </div>
                <div className='tipMaxBox'>
                    The THEi WIL Digital Platform is funded by the Quality Enhancement Support Scheme (QESS) - Formation and Development of a Work Integrated Learning Hub for Diverse Programmes of THEi (Project no.: IA03/QESS/2022).
                    Any opinions, findings, conclusions or recommendations expressed in this material/event (or by members of the project team) do not reflect the views of the Government of the Hong Kong Special Administrative Region, the Education Bureau, any member in the Committee on Self-financing Postsecondary Education (CSPE) and its Sub-committee on Support Measures, and the Secretariat of the CSPE and its Sub-committee on Support Measures.
                </div>
                <div className='loginLogoBox'>
                    <img src={zfzzjhImg} />
                </div>
            </div>
        </div>
    )
}

export default Login;